import { Environment } from './env.type';
import { baseEnvironment } from './base';

export const environment: Environment = {
    ...baseEnvironment,
    envName: 'development',
    // graphqlUrl: 'https://api-v2.visiolens.net.br/graphql',
    graphqlUrl: 'https://dev-api-v2.visiolens.net.br/graphql',
};
